<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpAguarde"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Lista de DMS-e</h5>
            <Loader :loading="httpSend">
              <b-form @submit.prevent="listAllDeclaracoes()" class="border-bottom mb-3">
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="Ano" label-for="dms_ano_ref">
                      <input
                          id="dms_ano_ref"
                          v-model="filtro.dms_ano_ref"
                          v-mask="'####'"
                          type="text"
                          maxlength="4"
                          class="form-control"
                          placeholder="Ano">
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Mês" label-for="dms_mes_ref">
                      <input
                          id="dms_mes_ref"
                          v-model="filtro.dms_mes_ref"
                          v-mask="'##'"
                          type="text"
                          maxlength="2"
                          class="form-control"
                          placeholder="Mês">
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                        label="'"
                        class="text-white">
                      <button type="submit"
                              class="btn btn-label btn-primary"><i
                          class="bx bx-search label-icon"></i>
                        Pesquisar
                      </button>
                    </b-form-group>
                  </div>
                </div>
              </b-form>
              <div v-show="!declaracoes || declaracoes.length < 1" role="alert" aria-live="polite"
                   aria-atomic="true" class="alert alert-primary text-center">
                Sem Declarações Mensal
              </div>
              <div v-for="d in declaracoes" :key="d.dms_codigo" class="row">
                <div class="col-md-12 mb-3 border-bottom border-dark">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group label="Código">
                        <h6 class="mb-0">{{ d.dms_codigo }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Competência">
                        <h6 class="mb-0">{{ d.dms_competencia | formatCompetencia }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Total das Notas">
                        <h6 class="mb-0">{{ d.dms_valornfe | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="DUAM">
                        <h6 class="mb-0">{{ d.dam_codigo }}</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group label="Tributável">
                        <h6 class="mb-0">{{ d.dms_basetributavel  | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="ISS Retido">
                        <h6 class="mb-0">{{ d.dms_valor_issretido  | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="ISS">
                        <h6 class="mb-0">{{ d.dms_valor_iss  | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Imposto de Renda">
                        <h6 class="mb-0">{{ d.dms_valor_irrf  | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button type="button" v-if="podeCancelar(d)" @click="ConfirmaCanelarDeclaracao(d)"
                              class="btn btn-outline-danger btn-sm mb-2 mr-2">
                        <i class="bx bx-block"></i> Cancelar Declaração
                      </button>
                      <button type="button" @click="pagamento(d)"
                              v-if="d.tab_106situacao ==='963' || d.tab_106situacao ==='964'"
                              title="Visualizar Guia"
                              class="btn btn-success btn-sm mr-2 mb-2">
                        <i class="bx bx-money"></i> Realizar Pagamento
                      </button>
                      <button type="button" @click="guiaDetalhe(d)" class="btn btn-dark btn-sm mb-2 mr-2">
                        <i class="bx bx-show-alt"></i> Detalhe
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import Loader from "@/components/widgets/loader";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {cancelaDeclaracoesMensal, listDeclaracoesMensal} from "@/api/financeiro/declaracoes";
import {getCompetencia} from "@/helps/util";
import Swal from "sweetalert2";
import {notifyErro, notifySucesso} from "@/helps/notificacao";

export default {
  page: {
    title: "Guias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Loader
  },
  data() {
    return {
      title: "Declaração Mensal de Serviços Eletrônica (DMS-e)",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Declaração Mensal',
          active: true,
        },
      ],
      httpAguarde: false,
      httpSend: false,
      filtro: {
        dms_ano_ref: "",
        dms_mes_ref: ""

      },
      declaracoes: []
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    this.listAllDeclaracoes();
  },
  methods: {
    podeCancelar(d) {
      let visivel = false;
      const dms_competencia = parseInt(d.dms_competencia);
      const v_competencia = (parseInt(getCompetencia()) - 1);
      const tab_106situacao = parseInt(d.tab_106situacao);
      if (dms_competencia >= v_competencia && tab_106situacao < 976) {
        visivel = true;
      }
      return visivel;
    },
    listAllDeclaracoes() {
      this.httpSend = true;
      listDeclaracoesMensal(this.empresa.eco_codigo, this.filtro).then(response => {
        if (response.status) {
          this.declaracoes = response.dados;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    ConfirmaCanelarDeclaracao(d) {
      Swal.fire({
        title: "Confirmação",
        html: `Deseja realmente cancelar a Declaração Mensal de Serviços Eletrônica n° ${d.dms_codigo} ?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.canelarDeclaracao(d);
        }
      });
    },
    canelarDeclaracao(d) {
      this.httpAguarde = true;
      cancelaDeclaracoesMensal(this.empresa.eco_codigo, d.dms_codigo).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.listAllDeclaracoes();
        } else {
          notifyErro("Erro Interno", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpAguarde = false;
      })
    },
    pagamento(d) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: d.dam_hash}
      })
    },
    guiaDetalhe(d) {
      this.$router.push({
        name: "contribuinte-financeiro-guia-detalhe",
        params: {dam_hash: d.dam_hash}
      })
    }
  }
};
</script>


